import {
  HomeIcon,
  UsersIcon,
  RocketLaunchIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { NavLink } from 'react-router-dom';
import { classNames } from '../../utilities';

const navigation = [
  { name: 'Mission Board', path: '/dashboard', icon: HomeIcon },
  // { name: 'Team', path: '/team', icon: UsersIcon },
  { name: 'Jobs', path: '/jobs', icon: Cog6ToothIcon },
  { name: 'New Strategic Partner', path: '/partners/registration', icon: RocketLaunchIcon },
]

export default function LayoutNavigationMenu(props) {

  return (
    <nav className="flex flex-1 flex-col">
      <ul role="list" className="flex flex-1 flex-col gap-y-7">
        <li>
          <ul role="list" className="-mx-2 space-y-1">
            {navigation.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => classNames(
                    isActive
                      ? 'bg-primary-700 text-white'
                      : 'text-primary-200 hover:bg-primary-700 hover:text-white',
                    'group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6',
                  )}
                >
                  {(isActive) => (
                    <>
                      <item.icon
                        aria-hidden="true"
                        className={classNames(
                          isActive ? 'text-white' : 'text-primary-200 group-hover:text-white',
                          'h-6 w-6 shrink-0',
                        )}
                      />
                      {item.name}
                    </>
                  )}

                </NavLink>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </nav>
  )
}
